import BlogInner from "../Component/UserEnd/BlogInner";
import Footer from "../Component/UserEnd/Footer";

function BlogInPage() {
    return (
        <>
            <BlogInner/>
            <Footer />
        </>
    );
}

export default BlogInPage;
